import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";

/**
 * 🔹 Payload para crear/actualizar
 */
export interface ResponsabilidadDesPlanPayload {
  id_responsabilidad: number;
  descripcion: string;
  estado?: number;
}

/**
 * 🔹 Interface de respuesta
 */
export interface ResponsabilidadDesPlan {
  id?: number;
  id_responsabilidad: number;
  descripcion: string;
  estado: number;
  fechaCreacion?: string;
  fechaModificacion?: string | null;
}

export interface ResponsabilidadDesPlanResponse {
  id?: number;
  message?: string;
  error?: string;
  data?: any;
  [key: string]: any;
}

@Injectable({
  providedIn: "root",
})
export class ResponsabilidadDesPlanService {
  private readonly apiUrl = `${environment.apiUrl}/api/responsabilidad_des_plan`;

  constructor(private http: HttpClient) {}

  // Listar todas las responsabilidades detalladas
  getAll(): Observable<ResponsabilidadDesPlan[]> {
    return this.http.get<ResponsabilidadDesPlan[]>(this.apiUrl, { withCredentials: true });
  }

  // Obtener por ID
  getById(id: number): Observable<ResponsabilidadDesPlan> {
    return this.http.get<ResponsabilidadDesPlan>(`${this.apiUrl}/${id}`, { withCredentials: true });
  }

  // Crear nueva responsabilidad detallada
  create(payload: ResponsabilidadDesPlanPayload): Observable<ResponsabilidadDesPlanResponse> {
    return this.http.post<ResponsabilidadDesPlanResponse>(this.apiUrl, payload, { withCredentials: true });
  }

  // Actualizar responsabilidad detallada
  update(id: number, payload: Partial<ResponsabilidadDesPlanPayload>): Observable<ResponsabilidadDesPlanResponse> {
    return this.http.put<ResponsabilidadDesPlanResponse>(`${this.apiUrl}/${id}`, payload, { withCredentials: true });
  }

  // Eliminar responsabilidad detallada (DELETE)
  remove(id: number): Observable<any> {
    return this.http.delete<any>(`${this.apiUrl}/${id}`, { withCredentials: true });
  }

  // Inactivar responsabilidad detallada
  inactivar(id: number): Observable<ResponsabilidadDesPlanResponse> {
    return this.http.put<ResponsabilidadDesPlanResponse>(`${this.apiUrl}/${id}/inactivar`, {}, { withCredentials: true });
  }

  // Activar responsabilidad detallada
  activar(id: number): Observable<ResponsabilidadDesPlanResponse> {
    return this.http.put<ResponsabilidadDesPlanResponse>(`${this.apiUrl}/${id}/activar`, {}, { withCredentials: true });
  }

getByIdResponsabilidad(id_responsabilidad: number): Observable<ResponsabilidadDesPlan[]> {
  return this.http.get<ResponsabilidadDesPlan[]>(`${this.apiUrl}/responsabilidad/${id_responsabilidad}`, { withCredentials: true });
}
}